import { Check, Clock, MessageSquare, Phone, Bell, Monitor, X } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { AlertStatus, AlertType } from '@/types/api';
import { cn } from '@/lib/cn';

const statusStyles: Record<AlertStatus, { label: string; icon: LucideIcon; className: string }> = {
  sent: { label: 'Delivered', icon: Check, className: 'bg-ok-soft text-ok border-ok/20' },
  pending: { label: 'Sending', icon: Clock, className: 'bg-warn-soft text-warn border-warn/20' },
  failed: { label: 'Failed', icon: X, className: 'bg-bad-soft text-bad border-bad/25' },
};

export function AlertStatusChip({ status }: { status: AlertStatus }) {
  const style = statusStyles[status];
  const Icon = style.icon;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[12px] font-medium',
        style.className
      )}
    >
      <Icon className="size-3" aria-hidden />
      {style.label}
    </span>
  );
}

const typeIcons: Record<AlertType, LucideIcon> = {
  SMS: MessageSquare,
  call: Phone,
  push: Bell,
  dashboard: Monitor,
};

const typeLabels: Record<AlertType, string> = {
  SMS: 'SMS',
  call: 'Voice call',
  push: 'Push notification',
  dashboard: 'Dashboard',
};

export function AlertTypeLabel({ type }: { type: AlertType }) {
  const Icon = typeIcons[type] ?? Monitor;
  return (
    <span className="inline-flex items-center gap-2 text-ink">
      <Icon className="size-4 text-ink-muted" aria-hidden />
      {typeLabels[type] ?? type}
    </span>
  );
}
